<section
	*ngIf="isMobile"
	id="checkout-screen-header-mobile"
	class="mobileSingleHeader"
>
	<img
		class="user-avatar dropdown-toggle"
		src="{{ userData && userData.imageUrl }}"
	/>
	<span class="pageTitle">{{ 'USERMENU.MEMBERSHIP' | translate }}</span>
	<fa-icon icon="times" class="times" routerLink="/account/premium"></fa-icon>
</section>

<main
	id="checkout-screen"
	class="zk-bg-grey-2 zk-relative zk-min-h-screen"
	[class.zk-pointer-events-none]="loadingCart || loadingPayment"
>
	<!-- tablet and desktop -->
	<!-- placeholder -->
	<div
		*ngIf="!cart"
		class="
			zk-hidden
			md:zk-grid
			lg:zk-container
			zk-mx-auto zk-grid-cols-2 zk-gap-4 zk-px-4
			lg:zk-px-6
			zk-pb-10 zk-pt-10 zk-animate-pulse
		"
	>
		<section>
			<div
				class="
					zk-flex
					zk-flex-col
					zk-justify-between
					zk-p-5
					zk-h-84
					zk-mb-4
					zk-bg-white
					zk-shadow-checkout-default
					zk-rounded-checkout-default
				"
			>
				<div class="zk-bg-grey-3 zk-h-6 zk-w-full zk-mb-2"></div>
				<div class="zk-bg-grey-3 zk-h-6 zk-w-full zk-mb-2"></div>
				<div class="zk-bg-grey-3 zk-h-6 zk-w-full zk-mb-2"></div>
				<div class="zk-bg-grey-3 zk-h-6 zk-w-full zk-mb-2"></div>
			</div>
			<div
				class="
					zk-flex
					zk-flex-col
					zk-justify-between
					zk-p-5
					zk-h-48
					zk-mb-4
					zk-bg-white
					zk-shadow-checkout-default
					zk-rounded-checkout-default
				"
			>
				<div class="zk-bg-grey-3 zk-h-6 zk-w-full zk-mb-2"></div>
				<div class="zk-bg-grey-3 zk-h-3 zk-w-full zk-mb-2"></div>
				<div class="zk-bg-grey-3 zk-h-3 zk-w-full zk-mb-2"></div>
				<div class="zk-bg-grey-3 zk-h-3 zk-w-full zk-mb-2"></div>
			</div>
		</section>
		<section>
			<div
				class="
					zk-h-48 zk-mb-4 zk-p-5
					lg:zk-p-6
					zk-bg-white zk-shadow-checkout-default zk-rounded-checkout-default
				"
			>
				<div class="zk-flex zk-h-full">
					<div
						class="
							zk-bg-grey-3
							zk-flex-none
							zk-h-10
							zk-w-10
							zk-border-2
							zk-border-solid
							zk-border-grey-2
							zk-rounded-full
						"
					></div>
					<div
						class="
							zk-flex
							zk-flex-col
							zk-justify-between
							zk-flex-1
							zk-ml-4
							zk-overflow-hidden
						"
					>
						<div class="zk-bg-grey-3 zk-h-3 zk-w-full zk-mb-2"></div>
						<div class="zk-bg-grey-3 zk-h-2 zk-w-full zk-mb-2"></div>
						<div class="zk-bg-grey-3 zk-h-2 zk-w-full zk-mb-2"></div>
						<div class="zk-bg-grey-3 zk-h-2 zk-w-full zk-mb-2"></div>
					</div>
				</div>
			</div>
			<div
				class="
					zk-flex
					zk-flex-col
					zk-justify-between
					zk-h-84
					zk-p-5
					zk-mb-4
					zk-bg-white
					zk-shadow-checkout-default
					zk-rounded-checkout-default
				"
			>
				<div class="zk-bg-grey-3 zk-h-6 zk-w-full zk-mb-2"></div>
				<div class="zk-bg-grey-3 zk-h-3 zk-w-full zk-mb-2"></div>
				<div class="zk-bg-grey-3 zk-h-3 zk-w-full zk-mb-2"></div>
				<div class="zk-bg-grey-3 zk-h-3 zk-w-full zk-mb-2"></div>
				<div class="zk-bg-grey-3 zk-h-3 zk-w-full zk-mb-2"></div>
			</div>
		</section>
	</div>
	<div
		class="
			zk-hidden
			md:zk-grid
			lg:zk-container
			zk-mx-auto zk-grid-cols-2 zk-gap-4 zk-px-4
			lg:zk-px-6
			zk-pb-10 zk-pt-10
		"
		*ngIf="cart"
	>
		<section>
			<zk-checkout-products
				*ngIf="visibleProducts"
				[products]="cart.products"
				[currency]="cart.currency"
				(updateCart)="updateCart($event)"
				[labelDiscount]="'CHECKOUT.COMPONENTS.DISCOUNT' | translate"
				[title]="'CHECKOUT.PLANS' | translate"
			>
			</zk-checkout-products>
			<zk-checkout-payment-methods
				[paymentMethods]="cart.paymentMethods"
				[disableMethods]="disablePaymentMethods()"
				(updateCart)="updateCart($event)"
				[boletoRegions]="regions"
				[showBankTransfer]="true"
				[showBoleto]="true"
				[stripe]="stripe"
				[stripeCardCvcOptions]="stripeCardCvcOptions"
				[stripeCardExpiryOptions]="stripeCardExpiryOptions"
				[stripeCardNumberOptions]="stripeCardNumberOptions"
				[stripeService]="stripeService"
				[boletoMessage]="'CHECKOUT.BOLETO_FORM.MESSAGE' | translate"
				[labelAddNewCard]="'CHECKOUT.ADD_NEW_CARD' | translate"
				[labelAddNewPayment]="'CHECKOUT.ADD_NEW_PAYMENT' | translate"
				[labelBankTransfer]="'CHECKOUT.BANK_TRANSFER' | translate"
				[labelBoletoAddress]="'CHECKOUT.BOLETO_FORM.ADDRESS' | translate"
				[labelBoletoCity]="'CHECKOUT.BOLETO_FORM.CITY' | translate"
				[labelBoletoEditButton]="'CHECKOUT.BOLETO_FORM.BUTTON_EDIT' | translate"
				[labelBoletoFiscalId]="'CHECKOUT.BOLETO_FORM.FISCAL_ID' | translate"
				[labelBoletoMobileNextButton]="'CHECKOUT.CONTINUE' | translate"
				[labelBoletoRegions]="'CHECKOUT.BOLETO_FORM.REGION' | translate"
				[labelBoletoSaveButton]="'CHECKOUT.BOLETO_FORM.BUTTON_SAVE' | translate"
				[labelBoletoZipCode]="'CHECKOUT.BOLETO_FORM.POSTAL_CODE' | translate"
				[labelCardNumber]="'CHECKOUT.CARD_NUMBER' | translate"
				[labelChange]="'CHECKOUT.COMPONENTS.BUTTON_CHANGE' | translate"
				[labelCreditDebitCard]="'CHECKOUT.CREDIT_CARD' | translate"
				[labelNextButton]="'CHECKOUT.CONTINUE' | translate"
				[labelSavedPayment]="'CHECKOUT.SAVED_PAYMENT' | translate"
				[labelStripeCardAddButton]="
					'CHECKOUT.COMPONENTS.BUTTON_ADD' | translate
				"
				[labelStripeCardNameOnTheCard]="'CHECKOUT.CARD_NAME' | translate"
				[labelStripeCardSaveCard]="'CHECKOUT.CARD_SAVE' | translate"
				[nextScreenTitle]="'CHECKOUT.PAYMENT_METHOD' | translate"
				[title]="'CHECKOUT.PAYMENT_METHODS' | translate"
				[boletoInvalidMessages]="boletoInvalidMessages"
			>
			</zk-checkout-payment-methods>
			<zk-checkout-voucher
				*ngIf="cart.vouchers?.visible"
				[vouchers]="cart.vouchers"
				(updateCart)="updateCart($event)"
				[labelApplyButton]="'CHECKOUT.APPLY' | translate"
				[labelApplySuccess]="'CHECKOUT.APPLY_SUCCESS' | translate"
				[labelInsertTheVoucher]="
					'CHECKOUT.VOUCHER_INPUT_PLACEHOLDER' | translate
				"
				[labelRemoveButton]="'CHECKOUT.REMOVE' | translate"
				[labelVoucher]="'CHECKOUT.VOUCHER' | translate"
				[title]="'CHECKOUT.VOUCHER' | translate"
				[titleSavedVouchers]="'CHECKOUT.SAVED_VOUCHERS' | translate"
			></zk-checkout-voucher>
		</section>
		<section>
			<app-checkout-items [cart]="cart"></app-checkout-items>

			<zk-checkout-suggested
				*ngIf="
					cart.suggestedContent && !cart.suggestedContent?.suggestion.isSelected
				"
				[suggested]="cart.suggestedContent"
				(updateCart)="updateCart($event)"
				[labelAddButton]="'CHECKOUT.COMPONENTS.BUTTON_ADD' | translate"
			>
				<p
					class="
						zk-text-base zk-leading-normal zk-text-primary-new-lighter zk-mb-3
					"
				>
					{{ cart.suggestedContent?.plan?.name }}
				</p>
				<p class="zk-text-white-base zk-leading-normal zk-mb-0">
					<span class="zk-font-bold zk-text-lg">
						{{ cart.currency | zkCurrencySymbol }}
						{{ cart.suggestedContent?.plan?.price | zkPrice: cart.currency }}
					</span>
					<span
						*ngIf="cart.suggestedContent?.plan?.period"
						class="zk-font-base"
					>
						/
						{{
							(cart.suggestedContent?.plan?.period.period === 'year'
								? 'L_YEAR'
								: 'L_MONTH'
							)
								| translate
								| titlecase
						}}
					</span>
				</p>
			</zk-checkout-suggested>

			<zk-checkout-summary
				[loadingCart]="loadingCart"
				[loadingPayment]="loadingPayment"
				[summary]="cart.summary"
				[currency]="cart.currency"
				[items]="handleCartItems()"
				[paymentMethodType]="selectedPaymentType"
				[isPaymentAllowed]="checkPaymentMethod()"
				(finalizeCart)="finalizeCart()"
				[labelConfirmPaymentButton]="'CHECKOUT.CONFIRM_PAYMENT' | translate"
				[labelTotal]="'CHECKOUT.TOTAL' | translate"
				[paymentSecureTitle]="'CHECKOUT.SAFE_PAYMENT' | translate"
				[title]="'CHECKOUT.PAYMENT_SUMMARY' | translate"
			>
				<p
					class="
						zk-text-base zk-leading-normal zk-text-primary-new-lighter zk-mb-3
					"
				>
					{{ cart.suggestedContent?.plan?.name }}
				</p>
				<p class="zk-text-white-base zk-leading-normal zk-mb-0">
					<span class="zk-font-bold zk-text-lg">
						{{ cart.currency | zkCurrencySymbol }}
						{{ cart.suggestedContent?.plan?.price | zkPrice: cart.currency }}
					</span>
					<span
						*ngIf="cart.suggestedContent?.plan?.period"
						class="zk-font-base"
					>
						/
						{{
							(cart.suggestedContent?.plan?.period.period === 'year'
								? 'L_YEAR'
								: 'L_MONTH'
							)
								| translate
								| titlecase
						}}
					</span>
				</p>
			</zk-checkout-summary>
		</section>
	</div>
	<!-- mobile -->
	<div class="md:zk-hidden zk-flex zk-flex-col">
		<nav
			class="zk-flex zk-items-center zk-relative zk-w-full zk-h-12 zk-bg-white"
		>
			<h2
				class="
					zk-inline-block
					zk-m-0
					zk-absolute
					zk-left-1/2
					zk-transform
					zk--translate-x-1/2
					zk-text-1
					zk-font-base
					zk-text-lg
					zk-leading-normal
				"
			>
				{{ 'CHECKOUT.TITLE' | translate }}
			</h2>
		</nav>
		<!-- placeholder -->
		<div
			*ngIf="!cart"
			class="
				zk-flex
				zk-flex-col
				zk-mx-auto
				zk-px-3
				zk-mt-4
				zk-pb-8
				zk-w-full
				zk-animate-pulse
			"
		>
			<div
				class="
					zk-h-48 zk-mb-4 zk-p-5
					lg:zk-p-6
					zk-bg-white zk-shadow-checkout-default zk-rounded-checkout-default
				"
			>
				<div class="zk-flex zk-h-full">
					<div
						class="
							zk-bg-grey-3
							zk-flex-none
							zk-h-10
							zk-w-10
							zk-border-2
							zk-border-solid
							zk-border-grey-2
							zk-rounded-full
						"
					></div>
					<div
						class="
							zk-flex
							zk-flex-col
							zk-justify-between
							zk-flex-1
							zk-ml-4
							zk-overflow-hidden
						"
					>
						<div class="zk-bg-grey-3 zk-h-6 zk-w-full zk-mb-2"></div>
						<div class="zk-bg-grey-3 zk-h-4 zk-w-full zk-mb-2"></div>
						<div class="zk-bg-grey-3 zk-h-2 zk-w-full zk-mb-2"></div>
						<div class="zk-bg-grey-3 zk-h-2 zk-w-full zk-mb-2"></div>
						<div class="zk-bg-grey-3 zk-h-2 zk-w-full zk-mb-2"></div>
					</div>
				</div>
			</div>
			<div
				class="
					zk-h-16 zk-mb-4 zk-p-5
					lg:zk-p-6
					zk-bg-white zk-shadow-checkout-default zk-rounded-checkout-default
				"
			>
				<div class="zk-bg-grey-3 zk-h-6 zk-w-full zk-mb-2"></div>
			</div>
			<div
				class="
					zk-h-16 zk-mb-4 zk-p-5
					lg:zk-p-6
					zk-bg-white zk-shadow-checkout-default zk-rounded-checkout-default
				"
			>
				<div class="zk-bg-grey-3 zk-h-6 zk-w-full zk-mb-2"></div>
			</div>
			<div
				class="
					zk-flex zk-flex-col zk-justify-between zk-h-48 zk-mb-4 zk-p-5
					lg:zk-p-6
					zk-bg-white zk-shadow-checkout-default zk-rounded-checkout-default
				"
			>
				<div class="zk-bg-grey-3 zk-h-6 zk-w-full zk-mb-2"></div>
				<div class="zk-bg-grey-3 zk-h-2 zk-w-full zk-mb-2"></div>
				<div class="zk-bg-grey-3 zk-h-2 zk-w-full zk-mb-2"></div>
				<div class="zk-bg-grey-3 zk-h-2 zk-w-full zk-mb-2"></div>
			</div>
		</div>
		<div
			*ngIf="cart"
			class="zk-flex zk-flex-col zk-mx-auto zk-px-3 zk-mt-4 zk-pb-8 zk-w-full"
		>
			<app-checkout-items [cart]="cart"></app-checkout-items>

			<zk-checkout-suggested
				*ngIf="
					cart.suggestedContent && !cart.suggestedContent?.suggestion.isSelected
				"
				[suggested]="cart.suggestedContent"
				(updateCart)="updateCart($event)"
				[labelAddButton]="'CHECKOUT.COMPONENTS.BUTTON_ADD' | translate"
			>
				<p
					class="
						zk-text-base zk-leading-normal zk-text-primary-new-lighter zk-mb-3
					"
				>
					{{ cart.suggestedContent?.plan?.name }}
				</p>
				<p class="zk-text-white-base zk-leading-normal zk-mb-0">
					<span class="zk-font-bold zk-text-lg">
						{{ cart.currency | zkCurrencySymbol }}
						{{ cart.suggestedContent?.plan?.price | zkPrice: cart.currency }}
					</span>
					<span
						*ngIf="cart.suggestedContent?.plan?.period"
						class="zk-font-base"
					>
						/
						{{
							(cart.suggestedContent?.plan?.period.period === 'year'
								? 'L_YEAR'
								: 'L_MONTH'
							)
								| translate
								| titlecase
						}}
					</span>
				</p>
			</zk-checkout-suggested>

			<div
				class="zk-mb-4"
				*ngIf="cart.products?.visible && cart.products.data?.length > 0"
			>
				<zk-checkout-products-mobile
					[products]="cart.products"
					[currency]="cart.currency"
					(updateCart)="updateCart($event)"
				>
				</zk-checkout-products-mobile>
			</div>

			<div class="zk-mb-4" *ngIf="!disablePaymentMethods()">
				<zk-checkout-payment-methods-mobile
					[disableMethods]="disablePaymentMethods()"
					[paymentMethods]="cart.paymentMethods"
					[vouchers]="cart.vouchers"
					(updateCart)="updateCart($event)"
					[boletoRegions]="regions"
					[showBankTransfer]="true"
					[showBoleto]="true"
					[stripe]="stripe"
					[stripeCardCvcOptions]="stripeCardCvcOptions"
					[stripeCardExpiryOptions]="stripeCardExpiryOptions"
					[stripeCardNumberOptions]="stripeCardNumberOptions"
					[stripeService]="stripeService"
					[boletoMessage]="'CHECKOUT.BOLETO_FORM.MESSAGE' | translate"
					[labelAddNewCard]="'CHECKOUT.ADD_NEW_CARD' | translate"
					[labelAddNewPayment]="'CHECKOUT.ADD_NEW_PAYMENT' | translate"
					[labelAddVoucher]="'CHECKOUT.ADD_VOUCHER' | translate"
					[labelBankTransfer]="'CHECKOUT.BANK_TRANSFER' | translate"
					[labelBoletoAddress]="'CHECKOUT.BOLETO_FORM.ADDRESS' | translate"
					[labelBoletoCity]="'CHECKOUT.BOLETO_FORM.CITY' | translate"
					[labelBoletoEditButton]="
						'CHECKOUT.BOLETO_FORM.BUTTON_EDIT' | translate
					"
					[labelBoletoFiscalId]="'CHECKOUT.BOLETO_FORM.FISCAL_ID' | translate"
					[labelBoletoMobileNextButton]="'CHECKOUT.CONTINUE' | translate"
					[labelBoletoRegions]="'CHECKOUT.BOLETO_FORM.REGION' | translate"
					[labelBoletoSaveButton]="
						'CHECKOUT.BOLETO_FORM.BUTTON_SAVE' | translate
					"
					[labelBoletoZipCode]="'CHECKOUT.BOLETO_FORM.POSTAL_CODE' | translate"
					[labelChange]="'CHECKOUT.COMPONENTS.BUTTON_CHANGE' | translate"
					[labelCreditDebitCard]="'CHECKOUT.CREDIT_CARD' | translate"
					[labelInsertTheVoucher]="
						'CHECKOUT.VOUCHER_INPUT_PLACEHOLDER' | translate
					"
					[labelNextButton]="'CHECKOUT.CONTINUE' | translate"
					[labelSavedPayment]="'CHECKOUT.SAVED_PAYMENT' | translate"
					[labelSavedVouchers]="'CHECKOUT.SAVED_VOUCHERS' | translate"
					[labelStripeCardAddButton]="
						'CHECKOUT.COMPONENTS.BUTTON_ADD' | translate
					"
					[labelStripeCardNameOnTheCard]="'CHECKOUT.CARD_NAME' | translate"
					[labelStripeCardSaveCard]="'CHECKOUT.CARD_SAVE' | translate"
					[labelVoucher]="'CHECKOUT.VOUCHERS' | translate"
					[labelVoucherAdded]="'CHECKOUT.VOUCHER_ADDED' | translate"
					[nextScreenTitle]="'CHECKOUT.PAYMENT_METHOD' | translate"
					[title]="'CHECKOUT.PAYMENT_METHODS' | translate"
					[boletoInvalidMessages]="boletoInvalidMessages"
				>
				</zk-checkout-payment-methods-mobile>
			</div>

			<zk-checkout-summary
				[loadingCart]="loadingCart"
				[loadingPayment]="loadingPayment"
				[summary]="cart.summary"
				[currency]="cart.currency"
				[items]="handleCartItems()"
				[paymentMethodType]="selectedPaymentType"
				[isPaymentAllowed]="checkPaymentMethod()"
				(finalizeCart)="finalizeCart()"
				[labelConfirmPaymentButton]="'CHECKOUT.CONFIRM_PAYMENT' | translate"
				[labelTotal]="'CHECKOUT.TOTAL' | translate"
				[paymentSecureTitle]="'CHECKOUT.SAFE_PAYMENT' | translate"
				[title]="'CHECKOUT.PAYMENT_SUMMARY' | translate"
			>
			</zk-checkout-summary>
		</div>
	</div>
</main>
